import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import './NoResultsFound.scss';

interface noResultsFoundProps {
    iconSize : string,
    noResultsTitle: string,
    noResultsMessage: string,
  }

export default function NoResultsFound({ iconSize, noResultsTitle, noResultsMessage }: noResultsFoundProps): JSX.Element {

    const t = useTranslation();

    return (
        <div className="no-results-container">
            <i className= {`fwe-icon fwe-icon-documents-no-data ${iconSize}`}></i>
            <p className="bold">{t(noResultsTitle)}</p>
            <p className="font-weight-light text-centered">{t(noResultsMessage)}</p>
        </div>
    )
}
